import { useCallback, useState } from "react"

export function useToggleSet<T = string>(): [Set<T>, (key: T) => void, () => void] {
  const [items, setItems] = useState<Set<T>>(() => new Set())
  const toggle = useCallback((key: T) => {
    setItems((prev) => {
      const next = new Set(prev)
      if (next.has(key)) next.delete(key)
      else next.add(key)
      return next
    })
  }, [])
  const clear = useCallback(() => setItems(() => new Set()), [])
  return [items, toggle, clear]
}
